<template>
    <div class="">

        <vx-tooltip class="position-icon" text="Ghi chú" position="top">
            <feather-icon icon="EditIcon" class="action-success icon-btn mt-4"
                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openPopupNote"/>
        </vx-tooltip>

        <vx-tooltip class="position-icon" :text="$t('button.call')" position="top"
                    v-if="userInfo.userRole == 'user' && isPermissionCall">
            <feather-icon icon="PhoneIcon" class="action-success icon-btn mt-4"
                          svgClasses="h-5 w-5 cursor-pointer"
                          @click="callToCustomer"/>
        </vx-tooltip>

        <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
            <feather-icon icon="EyeIcon" class="text-primary mt-4"
                          svgClasses="h-5 w-5 hover:text-success icon-btn" @click="editRecord"/>
        </vx-tooltip>
        <vs-popup class="holamundo" title="Ghi chú" :active.sync="popupNote" id="customer_note" v-if="popupNote">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea class="w-full" v-model="customerDetails.note"/>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full flex justify-end">
                    <vs-button class="mr-4" color="primary" @click="saveInfoCustomer">Lưu</vs-button>
                    <vs-button type="border" color="danger" @click="popupNote = false">Đóng</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo customer-info" title="Khách hàng" :active.sync="popupInfo" id="customer_info_popup"
                  v-if="popupInfo">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <div class="vx-row">
                            <div class="vx-col xl:w-2/3 md:w-1/2 w-full">
                                <!-- Col Header -->
                                <div class="flex items-end mb-3">
                                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none font-medium fsz">{{
                                            $t('menuCustomer.contactInfo')
                                        }}</span>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col xl:w-1/2 md:w-full w-full mt-4">
                                        <label class="vs-input--label required">Chi nhánh</label>
                                        <v-select class="w-full" v-model="customerInfo.organizationBranchId"
                                                  :options="organizationBranchOptions" :reduce="item => item.value"
                                                  name="branch" v-validate="'required'"></v-select>
                                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                                    </div>
                                    <!--                                    <div class="vx-col xl:w-1/4 w-1/2 mt-4">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label required">Họ</label>-->
                                    <!--                                        <vs-input class="w-full" v-model="firstNameModel" v-validate="'required'"-->
                                    <!--                                                  name="firstName"/>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>-->
                                    <!--                                    </div>-->

                                    <!--                                    <div class="vx-col xl:w-1/4 w-1/2 mt-4">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label required">Tên</label>-->
                                    <!--                                        <vs-input class="w-full" v-model="lastNameModel" v-validate="'required'"-->
                                    <!--                                                  name="lastName"/>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>-->
                                    <!--                                    </div>-->

                                    <div class="vx-col xl:w-1/2 w-full mt-4">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.customerName')
                                            }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.fullName" v-validate="'required'"
                                                  name="fullName"
                                                  disabled/>
                                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                                    </div>

                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.dayOfBirth')
                                            }}</label>
                                        <flat-pickr :config="configDatePickerInfo" v-model="customerInfo.birthday"
                                                    class="w-full vs-inputx vs-input--input normal"
                                                    v-validate="'required'"
                                                    name="dayOfBirth"/>
                                        <span class="text-danger text-sm">{{ errors.first('dayOfBirth') }}</span>
                                    </div>

                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label">{{ $t('menuCustomer.identityCard') }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.passport"
                                                  v-validate="'numeric|min:9|max:12'" name="identityCard"/>
                                        <span class="text-danger text-sm">{{ errors.first('identityCard') }}</span>
                                    </div>

                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.phoneNumber')
                                            }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.phoneNumber"
                                                  v-validate="'required|phone_rule|max:10|min:10|numeric'"
                                                  name="phoneNumber"/>
                                        <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                                    </div>

                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label">{{ $t('menuCustomer.weight') }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.weight" v-validate="'numeric'"
                                                  name="weight"/>
                                        <!-- <span class="text-danger text-sm">{{ errors.first('weight') }}</span> -->
                                    </div>

                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label">{{ $t('menuCustomer.job') }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.job" name="job"/>
                                    </div>
                                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label">{{ $t('menuCustomer.ethnic') }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.ethnic" name="ethnic"/>
                                        <span class="text-danger text-sm">{{ errors.first('ethnic') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label">{{ $t('menuCustomer.email') }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.email" v-validate="'email'"
                                                  name="email"/>
                                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                                        <label class="vs-input--label required">{{ $t('menuCustomer.gender') }}</label>
                                        <v-select class="w-full" v-model="customerInfo.gender" :options="genderOptions"
                                                  name="gender"
                                                  v-validate="'required'" :reduce="item => item.value"></v-select>
                                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4" v-if="showSelectedSourceType">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.sourceType')
                                            }}</label>
                                        <v-select class="w-full" v-model="customerInfo.sourceType"
                                                  :options="sourceTypeOptions"
                                                  name="sourceType"
                                                  v-validate="'required'" :reduce="item => item.value"
                                                  :disabled="isUpdate"></v-select>
                                        <span class="text-danger text-sm">{{ errors.first('sourceType') }}</span>
                                    </div>
                                    <div class="vx-col w-full mt-4">
                                        <label class="vs-input--label">Ghi chú</label>
                                        <vs-textarea class="w-full" v-model="customerInfo.note"/>
                                    </div>
                                </div>

                                <!--                <div class="vx-row mt-4" v-if="!isUpdate">-->
                                <!--                    <div class="vx-col w-full">-->
                                <!--                            <vs-checkbox v-model="autoCreateMedicalRecordCheck">Tự động tạo hồ sơ khám bệnh</vs-checkbox>-->
                                <!--                    </div>-->
                                <!--                </div>-->

                                <vs-divider class="mt-8"/>

                                <!-- Col Header -->
                                <div class="vx-col w-full mt-2 mb-3">
                                    <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none font-medium fsz">{{ $t('menuCustomer.address') }}</span>
                                </div>
                                <div class="vx-row">
                                    <!--                    <div class="vx-col xl:w-1/4 lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mt-2">-->
                                    <!--                        <label class="vs-input--label required">Quốc gia</label>-->
                                    <!--                        <v-select class="w-full" v-model="country" :clearable="false" :options="countryOptions"-->
                                    <!--                                  name="country"-->
                                    <!--                                  v-validate="'required'">-->
                                    <!--                            <span slot="no-options">{{ $t('menuCustomer.noOption') }}</span>-->
                                    <!--                        </v-select>-->
                                    <!--                        <span class="text-danger text-sm">{{ errors.first('country') }}</span>-->
                                    <!--                    </div>-->
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                                        <label class="vs-input--label required">{{ $t('menuCustomer.city') }}</label>
                                        <v-select class="w-full" v-model="province" :clearable="false"
                                                  :options="cityOptions"
                                                  name="city"
                                                  v-validate="'required'">
                                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.district')
                                            }}</label>
                                        <v-select class="" v-model="district" :clearable="false"
                                                  :options="districtOptions"
                                                  name="district"
                                                  v-validate="'required'">
                                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('district') }}</span>
                                    </div>

                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                                        <label class="vs-input--label required">{{ $t('menuCustomer.commune') }}</label>
                                        <v-select class="" v-model="subDistrict" :clearable="false"
                                                  :options="subDistrictOptions"
                                                  name="subDistrict"
                                                  v-validate="'required'">
                                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                                        <label class="vs-input--label required">{{
                                                $t('menuCustomer.houseNumber')
                                            }}</label>
                                        <vs-input class="w-full" v-model="customerInfo.houseNumber" name="houseNumber"
                                                  v-validate="''"/>
                                        <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>
                                    </div>
                                    <div class="vx-col xl:w-2/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuCustomer.address') }}</label>
                                        <vs-input class="w-full" v-model="fullAddressModel" name="full_address"
                                                  readonly/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col xl:w-1/3 md:w-1/2 w-full">
                                <div class="vx-col w-full md:mt-0 mt-6">
                                    <!-- Col Header -->
                                    <div class="flex justify-center mb-3">
                                        <feather-icon icon="MaximizeIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                        <span class="leading-none font-medium fsz mt-1">{{
                                                $t('menuCustomer.faceData')
                                            }}</span>
                                    </div>
                                    <div class="vx-row">
                                        <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                                                   @before-remove="beforeRemove" @edit-image="editImage"
                                                                   @data-change="dataChange"
                                                                   :data-images="images">
                                        </vue-upload-multiple-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <div id="call_history">
                            <div class="vx-row">
                                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 sm:mt-0 mt-2 w-full">
                                    <label class="vs-input--label">Loại</label>
                                    <v-select v-model="selectedTypeCallValue" :options="typeCallOptions"
                                              :clearable="false" name="employee" :reduce="item => item.value">
                                    </v-select>
                                </div>
                                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 md:mt-0 mt-2 w-full">
                                    <label class="vs-input--label">Ngày bắt đầu</label>
                                    <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                                                v-validate="'required'" :disabled-dates="disabledDates"
                                                v-model="startDate" name="Ngày bắt đầu" @update="dateRangePicker">
                                    </datepicker>
                                </div>
                                <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                                    <label class="vs-input--label">Ngày kết thúc</label>
                                    <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                                                v-validate="'required'" :disabled-dates="disabledDates"
                                                v-model="endDate" name="Ngày kết thúc" @update="dateRangePicker">
                                    </datepicker>
                                </div>
                                <div class="vx-col w-auto">
                                    <vs-button class="md:mt-6 sm:mt-8 mt-4" @click="filter">Tìm kiếm</vs-button>
                                </div>
                            </div>

                            <vs-table class="mt-6" :data="callHistoryData" noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        STT
                                    </vs-th>
                                    <vs-th>
                                        Người gọi
                                    </vs-th>
                                    <vs-th>
                                        Khách hàng
                                    </vs-th>
                                    <vs-th>
                                        SĐT KH
                                    </vs-th>
                                    <vs-th>
                                        Thời lượng
                                    </vs-th>
                                    <vs-th>
                                        Ngày
                                    </vs-th>
                                    <vs-th>
                                        Loại
                                    </vs-th>
                                    <vs-th>
                                        Trạng thái
                                    </vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>
                                            {{ tr.stt }}
                                        </vs-td>

                                        <vs-td>
                                            {{ tr.callerMem }}
                                        </vs-td>

                                        <vs-td>
                                            {{ tr.calleeMem }}
                                        </vs-td>

                                        <vs-td>
                                            {{ tr.calleeMemPhone }}
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.time_call }}
                                        </vs-td>

                                        <vs-td>
                                            {{ tr.createdDate }}
                                        </vs-td>

                                        <vs-td>
                                            <vs-chip class="ag-grid-cell-chip" :color="chipColorType(tr.type_call)">
                                                <span>{{ checkStatusType(tr.type_call) }}</span>
                                            </vs-chip>
                                        </vs-td>

                                        <vs-td class="flex">
                                            <vs-chip class="ag-grid-cell-chip" :color="chipColorStatus(tr.disposition)">
                                                <span>{{ checkStatusStatus(tr.disposition) }}</span>
                                            </vs-chip>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                            <div class="vx-row mt-4" v-if="callHistoryData.length > 0">
                                <div class="vx-col md:w-1/2">
                                    <div
                                        class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                                            <div
                                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        callHistoryData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : callHistoryData.length
                                    }} /
                                    {{ totalElements }}</span>
                                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                                            </div>
                                            <vs-dropdown-menu>
                                                <vs-dropdown-item @click="changePageSize(10)">
                                                    <span>10</span>
                                                </vs-dropdown-item>
                                                <vs-dropdown-item @click="changePageSize(20)">
                                                    <span>20</span>
                                                </vs-dropdown-item>
                                                <vs-dropdown-item @click="changePageSize(30)">
                                                    <span>30</span>
                                                </vs-dropdown-item>
                                                <vs-dropdown-item @click="changePageSize(50)">
                                                    <span>50</span>
                                                </vs-dropdown-item>
                                            </vs-dropdown-menu>
                                        </vs-dropdown>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                                </div>
                            </div>
                            <vs-popup class="holamundo" id="popup-history-call" :active.sync="showCallHistoryDetails">
                                <div class="vx-row">
                                    <div class="vx-col w-full flex justify-between">
                                        <h4>Cuộc gọi</h4>
                                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                                      @click="closeCallHistoryDetails"/>
                                    </div>
                                </div>

                                <vs-divider/>

                                <h5>Chi tiết</h5>
                                <div class="vx-row mt-4">
                                    <div class="vx-col w-full">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/3 flex items-center">
                                                <span class="text-md font-semibold">Loại</span>
                                            </div>
                                            <div class="vx-col w-2/3">
                                                <vs-chip class="ag-grid-cell-chip"
                                                         :color="callHistoryDetails ? chipColorType(callHistoryDetails.type_call) : null">
                                <span class="text-md font-semibold">{{
                                        callHistoryDetails ? checkStatusType(callHistoryDetails.type_call) : null
                                    }}</span>
                                                </vs-chip>
                                            </div>
                                        </div>
                                        <div class="vx-row mt-4">
                                            <div class="vx-col w-1/3">
                                                <span class="text-md font-semibold">Thời gian</span>
                                            </div>
                                            <div class="vx-col w-2/3">
                            <span
                                class="text-md">{{ callHistoryDetails ? callHistoryDetails.createdDate : null }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mt-4">
                                            <div class="vx-col w-1/3">
                                                <span class="text-md font-semibold">Thời lượng</span>
                                            </div>
                                            <div class="vx-col w-2/3">
                                            <span class="text-md">{{
                                                    callHistoryDetails ? callHistoryDetails.time_call : null
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mt-4">
                                            <div class="vx-col w-1/3">
                                                <span class="text-md font-semibold">Hotline</span>
                                            </div>
                                            <div class="vx-col w-2/3">
                            <span
                                class="text-md font-semibold">{{
                                    callHistoryDetails ? callHistoryDetails.hotline_number : null
                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <vs-divider/>

                                <h5>Người gọi</h5>
                                <div class="vx-row mt-4">
                                    <div class="vx-col w-1/2">
                                        <span>{{ callHistoryDetails ? callHistoryDetails.callerMem : null }}</span>
                                    </div>
                                    <div class="vx-col w-1/2"
                                         v-if="callHistoryDetails && callHistoryDetails.record_file.length > 0">
                                        <div v-for="(record, index) in callHistoryDetails.record_file" :key="index"
                                             class="text-primary float-right text-md font-semibold cursor-pointer flex items-center"
                                             @click="startRecord(record)">
                                            <span>{{ 'Tệp ghi âm ' + (index + 1) }}</span>
                                            <feather-icon icon="PlayCircleIcon" class="action-success icon-btn"
                                                          svgClasses="h-5 w-5"/>
                                        </div>
                                    </div>
                                </div>

                                <vs-divider/>

                                <h5>Người nhận</h5>
                                <div class="vx-row mt-4">
                                    <div class="vx-col w-1/2 flex items-center">
                    <span>{{
                            (callHistoryDetails && callHistoryDetails.callee.length > 0) ? (callHistoryDetails.calleeMem + ' - ' + callHistoryDetails.callee[0].phone) : 'Không xác định'
                        }}</span>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <vs-chip class="ag-grid-cell-chip float-right"
                                                 :color="callHistoryDetails ? chipColorStatus(callHistoryDetails.disposition) : null">
                        <span class="text-md font-semibold">{{
                                callHistoryDetails ? checkStatusStatus(callHistoryDetails.disposition) : null
                            }}</span>
                                        </vs-chip>
                                    </div>
                                </div>

                                <vs-divider/>

                                <h5>Đánh giá</h5>
                                <div class="vx-row mt-4">
                                    <div class="vx-col w-full">
                                        <star-rating v-model="rating" :star-size="25" :show-rating="false"
                                                     :read-only="isRating" :border-width="4"
                                                     border-color="#F3D23E"
                                                     active-color="#F3D23E" :rounded-corners="true"
                                                     :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                                     class="mt-2"></star-rating>
                                    </div>
                                    <div class="vx-col w-full">
                                        <vs-textarea class="w-full" v-model="review"
                                                     aria-placeholder="Nhập đánh giá ..."
                                                     :disabled="isRating"/>
                                    </div>
                                </div>

                                <div class="mt-4">
                                    <div class="flex float-right">
                                        <vs-button color="primary" @click="saveReviewCall" class="mr-4"
                                                   v-if="!isRating">
                                            Lưu
                                        </vs-button>
                                        <vs-button color="danger" type="border" @click="closeCallHistoryDetails">Đóng
                                        </vs-button>
                                    </div>
                                </div>

                                <!--Popup audio record-->
                                <vs-popup class="holamundo" id="popup-history-call-record"
                                          :active.sync="showAudioRecord">
                                    <div class="vx-row">
                                        <div class="vx-col w-full flex justify-between">
                                            <h4>Ghi âm</h4>
                                            <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                                          @click="closeAudioRecord"/>
                                        </div>
                                    </div>
                                    <vs-divider/>
                                    <div class="vx-row" v-if="showAudioRecord">
                                        <div class="vx-col w-full">
                                            <audio autoplay name="media" controls :src="dataRecord" type="audio/wav"
                                                   class="w-full">
                                            </audio>
                                        </div>
                                    </div>
                                </vs-popup>
                            </vs-popup>
                        </div>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <ConsultingStep :loyaltyCustomerId="params.data.id"></ConsultingStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <FeeCollectionStep :loyaltyCustomerId="params.data.id"></FeeCollectionStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <ParaclinicalExaminationStep :loyaltyCustomerId="params.data.id"></ParaclinicalExaminationStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <HistorySMS :loyaltyCustomerId="params.data.id"></HistorySMS>
                    </VuePerfectScrollbar>
                </vs-tab>
            </vs-tabs>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap justify-end gap-4">

                        <vs-button icon-pack="feather" icon="icon-phone-call" @click="callToCustomer" v-if="userInfo.userRole == 'user' && isPermissionCall">Gọi điện
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-mail" @click="sendSMS">Gửi SMS</vs-button>
                        <!--                        <vs-button icon-pack="feather" icon="icon-calendar">Đặt lịch</vs-button>-->
                        <vs-button icon-pack="feather" icon="icon-save" @click="saveChanges" :disabled="!validateForm"
                                   v-if="isPermissionUpdate && activeTab === 0">
                            Lưu
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-x" color="danger" type="border"
                                   @click="popupInfo = false">Đóng
                        </vs-button>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" title="Gửi SMS" :active.sync="popupSendSMSCustomer" id="send_sms_customer">
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Tổng đài</label>
                        <v-select class="w-full" v-model="smsSendInfo.smsBrandNameId"
                                  :options="brandNameOptions" :reduce="item => item.value">
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Nội dung</label>
                        <vs-textarea class="w-full" v-model="smsSendInfo.messageTitle"/>
                    </div>
                    <div class="vx-col w-full">
                        <div class="flex justify-end gap-4">
                            <vs-button icon-pack="feather" icon="icon-send" @click="send">Gửi</vs-button>
                            <vs-button icon-pack="feather" icon="icon-x" type="border" color="danger"
                                       @click="cancelSend">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import {isAPI} from "../../../../../store/permission";
import {constAPI} from "../../../../../store/constant";
import VueUploadMultipleImage from '../../../../../components/VueUploadMultipleImage';
import province from '../../../../../assets/utils/province.js';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from "vuejs-datepicker/dist/locale";
import moment from "moment";

import StarRating from 'vue-star-rating';
import authConfig from '../../../../../../auth_config.json';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';

import ConsultingStep from "./medical-step/ConsultingStep";
import FeeCollectionStep from "./medical-step/FeeCollectionStep";
import ParaclinicalExaminationStep from "./medical-step/ParaclinicalExaminationStep";
import HistorySMS from "./history-sms/HistorySMS";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: 'CellRendererActions',
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    components: {
        vSelect,
        flatPickr,
        VueUploadMultipleImage,
        Datepicker,
        StarRating,
        AgGridVue,
        ConsultingStep,
        FeeCollectionStep,
        ParaclinicalExaminationStep,
        HistorySMS,
        VuePerfectScrollbar
    },
    data() {
        return {
            activePopupCall: false,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            popupCreateFile: false,
            createdDate: new Date(),
            configDatePicker: {
                dateFormat: 'd-m-Y',
            },
            customerTypeOptions: [
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            healthInsuranceNum: null,
            reasonForExamination: null,
            noteReason: null,
            stepOptions: [
                {value: 1, label: 'Tiếp đón'},
                {value: 2, label: 'Tư vấn'},
                {value: 3, label: 'Thu phí'},
                {value: 4, label: 'Cận lâm sàng'},
                {value: 5, label: 'Hoàn thành'},
            ],
            selectedStepValue: null,
            employeeOptions: [],
            selectedEmployeeValue1: null,
            selectedEmployeeValue2: null,
            selectedDoctorValue: null,
            popupNote: false,
            customerDetails: null,
            popupInfo: false,
            organizationBranchOptions: [],
            cityOptions: province.getProvince(),
            // countryOptions: country.getCountry(),
            districtOptions: [],
            subDistrictOptions: [],
            isUpdate: false,
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: "Việt Nam",
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null,
                sourceType: null,
            },
            images: [],
            user_data: null,
            imagesId: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            customerId: null,
            configDatePickerInfo: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
            typeCustomer: [
                {value: 1, label: 'Khách hàng chính thức'},
                {value: 2, label: 'Khách hàng tiềm năng'},
            ],
            sourceTypeOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn cá nhân'},
            ],
            departmentData: [],
            showSelectedSourceType: false,
            employeeInfo: null,
            autoCreateMedicalRecordCheck: false,

            //Call history
            pageNumber: 0,
            pageSize: 10,
            currentPage: 1,
            totalPages: 1,
            totalElements: 0,
            callHistoryData: [],
            showCallHistoryDetails: false,
            callHistoryDetails: null,
            dataRecord: null,
            showAudioRecord: false,
            rating: null,
            isRating: false,
            review: null,
            // startDate: new Date(new Date(new Date().setMonth(new Date().getMonth()-1)).setHours(0,0,0,0)),
            // endDate: new Date(new Date().setHours(23,59,59,999)),
            startDate: null,
            endDate: null,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            selectedEmployeeValue: 'null',
            typeCallOptions: [
                {value: null, label: 'Tất cả'},
                {value: 'OUTCALL', label: 'Cuộc gọi đi'},
                {value: 'INCALL', label: 'Cuộc gọi đến'},
                {value: 'MISSCALL', label: 'Cuộc gọi nhỡ'},
            ],
            selectedTypeCallValue: null,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            activeTab: 0,
            brandNameOptions: [],
            popupSendSMSCustomer: false,
            configTimePicker: {
                minDate: new Date(),
                enableTime: true,
                time_24hr: true,
                locale: Vietnamese,
            },
            smsSendInfo: {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            }
        }
    },
    computed: {
        isPermissionCall() {
            return isAPI(this, constAPI.beauty_call)
        },
        validateForm() {
            return !this.errors.any()
        },
        // firstNameModel: {
        //     get() {
        //         return this.customerInfo.firstName;
        //     },
        //     set(value) {
        //         this.customerInfo.firstName = value;
        //     }
        // },
        // lastNameModel: {
        //     get() {
        //         return this.customerInfo.lastName;
        //     },
        //     set(value) {
        //         this.customerInfo.lastName = value;
        //     }
        // },
        // fullNameModel: {
        //     get() {
        //         let fullName = `${this.firstNameModel ? this.firstNameModel + ' ' : ''}${this.lastNameModel ? this.lastNameModel + ' ' : ''}`;
        //         // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //         this.customerInfo.fullName = fullName;
        //         return fullName;
        //     },
        // },
        // country: {
        //     get() {
        //         return {
        //             label: this.getLabelString(this.countryOptions.find(x => x.label === this.customerInfo.country)),
        //             value: this.customerInfo.country
        //         }
        //     },
        //     set(obj) {
        //         this.customerInfo.country = obj ? obj.label : null;
        //     }
        // },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.customerInfo.city)),
                    value: this.customerInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.customerInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.customerInfo.district = null;
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.customerInfo.street = null;
                } else {
                    this.customerInfo.city = null;
                    this.districtOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.district = null;
                    this.subDistrictOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.customerInfo.district)),
                    value: this.customerInfo.district
                }
            },
            set(obj) {
                this.customerInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, obj.value);
                this.customerInfo.street = null;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.customerInfo.street)),
                    value: this.customerInfo.street
                }
            },
            set(obj) {
                this.customerInfo.street = obj.value
            }
        },
        fullAddressModel: {
            get() {
                if (this.province.value && this.district.value && this.subDistrict.value) {
                    this.customerInfo.fullAddress = `${this.customerInfo.houseNumber ? this.customerInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}`;
                    return this.customerInfo.fullAddress;
                } else if (!this.province.value && this.isUpdate) {
                    return this.customerInfo.fullAddress;
                } else if (!this.province.value || !this.district.value || !this.subDistrict.value) {
                    return this.customerInfo.fullAddress;
                }
            },
        },
        chipColorType() {
            return value => {
                if (value == 'OUTCALL') {
                    return "success";
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'MISSCALL') {
                    return 'danger'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value == 'OUTCALL') {
                    return "Cuộc gọi đi";
                } else if (value == 'INCALL ') {
                    return 'Cuộc gọi đến'
                } else if (value == 'ANSWER') {
                    return 'Cuộc gọi nhỡ'
                }
            }
        },
        chipColorStatus() {
            return value => {
                if (value == 'MORE') {
                    return "success";
                } else if (value == 'MISSCALL') {
                    return 'warning'
                } else if (value == 'ANSWER') {
                    return 'success'
                } else if (value == 'BUSY') {
                    return 'danger'
                } else if (value == 'NOANSWER') {
                    return 'warning'
                } else if (value == 'CANCEL') {
                    return 'danger'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'warning'
                } else if (value == 'LOGOUT') {
                    return 'warning'
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'danger'
                }
            }
        },
        checkStatusStatus() {
            return value => {
                if (value == 'MORE') {
                    return "Nhiều trạng thái khác của cuộc gọi";
                } else if (value == 'MISSCALL') {
                    return 'Cuộc gọi nhỡ'
                } else if (value == 'ANSWER') {
                    return 'Nghe máy'
                } else if (value == 'BUSY') {
                    return 'Người nhận bận'
                } else if (value == 'NOANSWER') {
                    return 'Người nhận không trả lời'
                } else if (value == 'CANCEL') {
                    return 'Người gọi hủy cuộc gọi'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'Đã có người khác nghe máy'
                } else if (value == 'LOGOUT') {
                    return 'Đang trong trạng thái Logout'
                } else if (value == 'INCALL') {
                    return 'Đang trong cuộc gọi khác'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'Lỗi cuộc gọi'
                }
            }
        },
    },

    methods: {
        async editRecord() {
            const isCustomerPancake = this.rowData.isCustomerPancake.toString();
            this.$router.push(`/user/edit-customer?id=${this.rowData.loyaltyCustomer.id}&isCustomerPancake=${isCustomerPancake}`).catch(() => {
            })
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: this.$t('menuOrganization.noBranch'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.customerInfo.organizationId = this.userInfo.organization.id;

            await this.getDepartment();

            await this.checkSourceType();

            this.customerId = this.rowData.id;
            if (this.customerId) {
                this.isUpdate = true;
                await this.findById();
                for (const x of this.customerInfo.fileManagers) {
                    let data = await this.toDataURL(x.url);
                    let dataImage = data.xhr.response;
                    let metadata = {
                        type: 'image/jpeg'
                    };
                    let file = new File([dataImage], x.fileName, metadata);
                    this.images.push({
                        name: x.fileName,
                        path: data.imgBase64,
                        highlight: 1,
                        default: 1,
                        file: file,
                        type: 1,
                    });
                }
            }
            await this.getAllCallHistory();
            this.activeTab = 0;
            this.popupInfo = true;
        },
        callToCustomer() {
            let data = this.rowData;
            data['isCreateBooking'] = true;
            this.$eventBus.$emit("beauty-call", data);
        },
        getEmployee() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/employee/all', {}).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.employeeOptions = res.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    }
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        openPopupNote() {
            this.customerDetails = this.rowData;
            this.popupNote = true;
        },
        saveInfoCustomer() {
            this.$vs.loading();
            this.$crm.post(`/loyalty/customer/update-note/${this.customerDetails.id}`, this.customerDetails).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: this.$t('menuCustomer.updateCustomerSS'),
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.popupNote = false;
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        findById() {
            this.$vs.loading();
            return new Promise((resolve, reject) => {
                this.$crm.post(`/loyalty/customer/find-by-id?id=${this.customerId}`).then((response) => {
                    this.customerInfo = response.data;
                    if (!response.data.firstName && !response.data.lastName) {
                        this.customerInfo.lastName = response.data.fullName;
                    }
                    // this.customerInfo.cardId = response.data.cardId;
                    this.customerInfo.createdDateFormat = moment(response.data.createdDate).format('DD/MM/YYYY');
                    this.customerInfo.cardNumber = response.data.card ? response.data.card.number.toString().replace(/(.{4})/g, "$1  ") : null;
                    this.customerInfo.points = response.data.card ? response.data.card.points : null;
                    this.customerInfo.fullNameUpperCase = response.data.fullName.toString().replace(/(.{1})/g, "$1 ").toUpperCase()
                    // this.countryOptions = country.getCountry(this.customerInfo.country);
                    this.districtOptions = province.getDistrict(this.customerInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.isUpdate = true;
                    this.$vs.loading.close();
                    resolve(response);
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList.map(x => {
                x.type = x.type ? x.type : 0;
                return x;
            });
            // this.customerInfo.urlImage = fileList.length > 0 ? fileList[0].path : null;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuCustomer.undefined');
        },
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            const formData = new FormData();
            if (this.isUpdate) {
                formData.append('id', this.customerId);
                let newImages = this.images.filter(x => x.type === 0);
                if (newImages && newImages.length > 0) {
                    newImages.forEach(x => formData.append('newImages', x.file));
                    this.images = this.images.filter(x => x.type === 1);
                    this.images.forEach(x => formData.append('images', x.file));
                } else {
                    this.images.forEach(x => formData.append('images', x.file));
                }
            } else {
                this.customerInfo.autoCreateMedicalRecord = this.autoCreateMedicalRecordCheck;
                if (this.images.length > 0) this.images.forEach(x => formData.append('images', x.file));
            }

            const blob = new Blob([JSON.stringify(this.customerInfo)], {type: 'application/json'});
            formData.append('loyaltyCustomerDTO ', blob);

            let url = this.isUpdate ? `/loyalty/customer/update` : `/loyalty/customer/create`;
            this.$vs.loading();
            this.$crm.post(url, formData).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuCustomer.updateCustomerSS') : this.$t('menuCustomer.addCustomerSS')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.popupInfo = false;
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        handleClickUploadFile() {
            return new Promise((resolve, reject) => {
                let formData = new FormData(), config;
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    this.$vs.loading.close();
                    resolve(true);
                }).catch((err) => {
                    reject(true);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.customer_loyaly_update);
        },
        getDepartment() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/department/find-by-condition', {organizationBranchId: this.userInfo.organizationBranchId}).then(res => {
                    this.departmentData = res.data;
                    this.$vs.loading.close();
                    resolve();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        getEmployeeData(employeeId) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post(`/employee/find-by-id/${employeeId}`).then(res => {
                    this.employeeInfo = res.data;
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        async checkSourceType() {
            if (this.userInfo.userRole === 'user') {
                await this.getEmployeeData(this.userInfo.employeeId);
                let department = this.departmentData.find(el => el.id === this.employeeInfo.departmentDTO.id);
                if (department.type === 1 || department.type === 2) {
                    this.showSelectedSourceType = true;
                } else {
                    this.showSelectedSourceType = false;
                    this.customerInfo.sourceType = 3;
                }
            } else {
                this.showSelectedSourceType = false;
                this.customerInfo.sourceType = 4;
            }
        },
        //Call history
        dateRangePicker: function () {
            this.startDate = new Date(this.startDate.setHours(0, 0, 0, 0));
            this.endDate = new Date(this.endDate.setHours(23, 59, 59, 999));
        },
        getAllCallHistory() {
            this.$vs.loading();
            this.callHistoryData = [];
            let body = {
                page: this.pageNumber,
                size: this.pageSize,
                startDate: this.startDate,
                endDate: this.endDate,
                typeCall: this.selectedTypeCallValue,
                loyaltyCustomerId: this.rowData.id
            }

            this.$crm.post('/ott/vbot/search-call-history', body).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.callHistoryData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.callerMem = el.caller[0].employee.fullName;
                        el.calleeMem = (el.callee.length > 0 && el.callee[0].user) ? el.callee[0].user.fullName : 'Không xác định';
                        el.calleeMemPhone = el.callee.length > 0 ? el.callee[0].phone : null;
                        el.createdDate = moment(el.date_create).format('DD/MM/YYYY HH:mm:ss');
                        // el.typeCall = el.type_call == 'OUTCALL' ? 'Cuộc gọi đi' : el.type_call == 'INCALL' ? 'Cuộc gọi đến' : el.type_call == 'MISSCALL' ? 'Cuộc gọi nhỡ' : null;
                        return el;
                    });
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllCallHistory();
        },
        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllCallHistory();
            }
        },
        filter() {
            if (this.startDate > this.endDate) {
                return this.$vs.notify({
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllCallHistory();
        },
        async closeCallHistoryDetails() {
            if (this.dataRecord) await this.deleteRecordFile();
            this.showCallHistoryDetails = false;
            this.callHistoryDetails = null;
            this.rating = null;
            this.review = null;
            this.isRating = false;
        },
        async closeAudioRecord() {
            await this.deleteRecordFile();
            this.dataRecord = null;
            this.showAudioRecord = false;
        },
        startRecord(e) {
            let payload = {
                recordFileUrl: e
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/get-record-file', payload).then(res => {
                this.$vs.loading.close();
                if (res) {
                    this.dataRecord = authConfig.audioDomain + res.data;
                } else {
                    return this.$vs.notify({
                        text: 'Không tồn tại file ghi âm!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.showAudioRecord = true;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        saveReviewCall() {
            if (!this.rating) {
                return this.$vs.notify({
                    text: 'Vui lòng đánh giá chất lượng cuộc gọi!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let payload = {
                id: this.callHistoryDetails.id,
                rating: this.rating,
                review: this.review
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/call-history-rating', payload).then(() => {
                this.$vs.notify({
                    text: 'Đánh giá cuộc gọi thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.closeCallHistoryDetails();
                this.getAllCallHistory();
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        deleteRecordFile() {
            return new Promise((resolve, reject) => {
                let payload = {
                    recordFileUrl: this.dataRecord,
                }

                this.$vs.loading();
                this.$crm.post('/ott/vbot/delete-record-file', payload).then(() => {
                    resolve();
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        //Send SMS
        async sendSMS() {
            await this.getBrandName();
            this.popupSendSMSCustomer = true;
        },
        getBrandName() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/sms-brand-name/get-all').then(res => {
                    if (res.data && res.data.length > 0) {
                        this.brandNameOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.brandName,
                            }
                        })
                    }
                    this.$vs.loading.close();
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        cancelSend() {
            this.smsSendInfo = {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            }
            this.popupSendSMSCustomer = false;
        },
        send() {
            let payload = {
                messageType: 1,
                loyaltyCustomerIds: [this.rowData.id],
                message: this.smsSendInfo.messageTitle,
                smsBrandNameId: this.smsSendInfo.smsBrandNameId,
                sendTimeStr: moment(new Date().toISOString()).format('yyyyMMDDHHmmss'),
                sendStatus: 1,
            }
            this.$vs.loading();
            this.$crm.post('/sms-message-config/create', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Gửi tin nhắn thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.cancelSend();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },

    async destroyed() {
        if (this.dataRecord) await this.deleteRecordFile();
    }
}
</script>

<style lang="scss">
.consultation_call {
    .vs-popup--header {
        //display: none;
    }

    .vs-popup--content {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
    }

    .view_details_call {
        .vx-row {
            margin: 0 !important;
        }
    }
}

#customer_note {
    .vs-con-textarea {
        min-height: 200px;

        textarea {
            min-height: 200px;
        }
    }
}

#customer_info_popup {

    @media (min-width: 1280px) {
        .vs-popup {
            width: 1200px !important;
        }
    }

    @media (max-width: 1279px) and (min-width: 1024px) {
        .vs-popup {
            width: 1000px !important;
        }
    }

    @media (max-width: 1023px) and (min-width: 768px) {
        .vs-popup {
            width: 700px !important;
        }
    }

    @media (max-width: 767px) and (min-width: 640px) {
        .vs-popup {
            width: 600px !important;
        }
    }

    .vs-textarea {
        height: 200px;
    }

    .membership_card_silver_rank {
        width: 300px;
        height: 150px;
        border-radius: 20px;
        background: linear-gradient(to bottom right, #f9f295, #e0aa3e, #f7ef8a, #b88a44);
    }

    .membership_card_gold_rank {
        width: 328px;
        height: 178px;
        border-radius: 20px;
        background: linear-gradient(to bottom right, #f9f295, #e0aa3e, #f7ef8a, #b88a44);
    }

    .membership_card_platinum_rank {
        width: 328px;
        height: 178px;
        border-radius: 20px;
        background: radial-gradient(circle at 14% 75%, #D3D3D3, #A9A9A9);
    }

    .vs-popup--content {
        min-height: 500px;

        .con-slot-tabs {
            min-height: 500px;
        }
    }

    .scroll-area--nofications-dropdown, .scroll-area--cart-items-dropdowm {
        max-height: 40rem;
    }
}

#popup-history-call {
    .vs-popup--header {
        display: none;
    }
}

#popup-history-call-record {
    .vs-popup--header {
        display: none;
    }
}

.nostar_desc {
    display: none !important;
}

#call_history {
    min-height: 400px;
}
</style>
